import React, { Component } from 'react';
import { Table } from 'antd';
import DataTable from '../../../../Assets/data/Datatable';
import {errorHandle} from "../../../Common/errorHandle";

class Proposals extends Component {

    state = {
      proposals_data: [],
      proposal_pagination: { showSizeChanger: false, pageSize: 15 },
      loader: false,
    }


    componentDidMount = () => {
      // Get Proposal Listing
      this.setState({loader: true});
      this.props.getProposalsListing({ limit: 15, offset: 0})
    }

    UNSAFE_componentWillReceiveProps = (props) => {
      let { proposal_pagination } = this.state;
      
      if (props?.GetProposal?.data && 
        Object.keys(props?.GetProposal?.data).length > 0 &&
        props?.GetProposal?.data !== this.props?.GetProposal?.data) 
      {
        proposal_pagination.total = props.GetProposal.data.count;

        this.setState({
          loader: false,
          proposal_pagination,
          proposals_data: props.GetProposal.data.results
        })
      }

      if (props?.GetProposal?.errors &&
        Object.keys(props?.GetProposal?.errors).length > 0 &&
        props?.GetProposal?.errors !== this.props?.GetProposal?.errors)
      {
        errorHandle(props.GetProposal.errors);
        this.setState({loader: false});
      }

      this.setState({loader: false});
    }

    //Proposal PAgination Change
    ProposalChange = (pagination) => {
      let { proposal_pagination } = this.state;

      proposal_pagination = Object.assign(proposal_pagination, { 'current': pagination.current });
      this.setState({
        proposal_pagination,
        loader: true,
      })

      this.props.getProposalsListing({ offset: (pagination.current * 15) - 15, limit: 15})
    }

    render() {
      let { loader, proposal_pagination, proposals_data } = this.state;
      return (
        <div className="invoice_wrapper">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="invoice_table ">
                  <div className="table-responsive">
                    <div className="col-md-12">

                      
                      <Table
                        rowKey={record => record.uuid}
                        dataSource={proposals_data}
                        pagination={proposal_pagination}
                        columns={DataTable.Proposals(this)}
                        onChange={this.ProposalChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {
            loader ?
              <div className='loader_wrapper'>
                <div className='loader07'></div>
              </div>
              : ''
          }
        </div>
      );
    }
}

export default Proposals;